<template>
   <div class="profile__popover">
       <div class="profile__header" @click.stop="goToProfile(user)">
           <Img :src="urlForDownload(user.avatar_url, 512)" alt="user avatar" :lazy="false" classname="avatar" :size="48"/>
           <div class="profile__content">
               <div class="profile__name-wrapper">
                   <p class="profile__name">
                    {{user.info.name}} {{user.info.surname}}
                   </p>
                   <span class="profile__block" v-if="!user.enabled">Заблокирован</span>
               </div>
               <p class="profile__name" v-if="user.info.work_phone">Телефон: {{user.info.work_phone}}</p>
           </div>
       </div>
       <div class="profile__divider"></div>
       <div class="profile__departments" v-if="departments.length > 0 && !inSideBar">
           <div class="profile__department--content" v-for="department in departments" :key="department.id">
               <div class="profile__department--item" @click.stop="goToProfile(department)">
                   <Img :src="urlForDownload(department.avatar_url, 512)" alt="user avatar" :lazy="false" classname="avatar" :size="24"/>
                   {{department.name}}
               </div>
           </div>
       </div>
       <div class="profile__departments" v-else-if="departments.length > 0">
           <div class="profile__department--content" >
               <div class="profile__department--item" @click.stop="goToProfile(departments[0])">
                   <Img :src="urlForDownload(departments[0].avatar_url, 512)" alt="user avatar" :lazy="true" classname="avatar" :size="24"/>
                   {{departments[0].name}}
               </div>
           </div>
       </div>
       <div v-else class="profile__department_empty">Нет отделов</div>
       <div class="profile__logout" v-if="inSideBar" @click="() => logout && logout()">
           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M21 12H11" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M18 15L20.913 12.087C20.961 12.039 20.961 11.961 20.913 11.913L18 9" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M16 5.41362V4.94317C16 4.16369 15.3284 3.5318 14.5 3.5318H5C3.89543 3.5318 3 4.37432 3 5.41362V18.5864C3 19.6257 3.89543 20.4682 5 20.4682H14.5C15.3284 20.4682 16 19.8363 16 19.0568V18.5864" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
           </svg>
           <span class="profile__logout_text">Выйти</span>
       </div>
   </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {Department, User} from "@/domain/user";
import {getDepartmentById} from "@/core/userInteraction";
import Img from "@/components/ui/Img/Img.vue"
import {urlForDownload} from "@/core/utils";

export default defineComponent({
    name: "profilePopover",
    components: {
        Img,
    },
    props: {
        user: {
            type: Object as PropType<User>,
            required: true
        },
        inSideBar: {
            defualt: false,
            type: Boolean
        },
        logout: {
            type: Function,
        }
    },
    computed: {
        departments(): Department[] {
            if (this.user.department_ids && this.user.department_ids.length > 0) {
                const departments = [] as Department[]
                for (let i = 0; i < this.user.department_ids.length; i++) {
                    const department = getDepartmentById(this.user.department_ids[i])
                    if (department) departments.push(department)
                }

                return departments
            }
            return []
        }
    },
    methods: {
        urlForDownload,
        goToProfile<T extends Department | User>(param: T) {
            const routeName = 'username' in param ?  'Profile' : 'Department';
            this.$router.push({ name: routeName, params: { id: param.id } })
        },

    }
})
</script>

<style scoped>
.profile__name {
    padding-left: 12px;

    @media (max-width: 768px) {
        white-space: normal;
        width: 170px;
    };
}

.profile__name-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
}

.profile__avatar {
    width: 60px;
    height: 60px;
}

.profile__departments {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 24px;
}

.profile__departments > :nth-child(7) {
  display: block;
  grid-column: span 1;
}


.profile__block {
    display: inline-block;
    background-color: #e4e4e4;
    color: #999999;
    font-weight: 600;
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 6px;
}

.dark .profile__block {
    color: var(--text-color);
    background-color: var(--dark-bg-700);
}

.profile__logout {
    color: var(--text-color);
    display: flex;
    align-items: center;
    justify-content: center;
    justify-self: flex-start;
    gap: 8px;
    align-self: flex-start;
    margin-top: 20px;
}

.profile__logout svg path {
    stroke: var(--text-color);
}

.profile__department_empty {
    color: var(--text-color);
}
</style>